import * as React from 'react';

import { customFrequencyUtils } from 'app-components/flux/scheduled-transactions';
import type { RecurrenceType } from 'app-components/flux/scheduled-transactions/customFrequencyTypes';

const { clearState } = customFrequencyUtils;

export type contextTypes = {
  state: RecurrenceType;
  dispatch: React.Dispatch<any>;
  error: boolean;
};

const defaultVals = {
  state: clearState,
  dispatch: () => {},
  error: false,
};

const FrequencyContext = React.createContext<contextTypes>(defaultVals);
FrequencyContext.displayName = 'Frequency Context';
export { FrequencyContext };
